import { createTypes, createAction } from "lib/action";
const UPDATE_PASSWORD_MASTERDATA_USER = createTypes("updatepasswordmasterdatauser", "update");
const REMOVE_LISTS = `REMOVE_LISTS`;

function removeLists() {
    return {
        type: REMOVE_LISTS
    };
}

const updatePasswordMasterDataUser = {
    request: (accessToken, data, loading) =>
        createAction(UPDATE_PASSWORD_MASTERDATA_USER.REQUEST, { accessToken, data, loading}),
    success: res => createAction(UPDATE_PASSWORD_MASTERDATA_USER.SUCCESS, { res }),
        failure: (error) => createAction(UPDATE_PASSWORD_MASTERDATA_USER.FAILURE, { error })
}

export {
    UPDATE_PASSWORD_MASTERDATA_USER,
    updatePasswordMasterDataUser,
    REMOVE_LISTS,
    removeLists
};